// extracted by mini-css-extract-plugin
export var chevronIcon = "_e6-2";
export var teamName = "_e6-1";
export var teamSwitcherButton = "_e6-0";